import * as XLSX from 'xlsx';

/**
 * 정산 ID 리스트 엑셀 템플릿을 클라이언트에서 즉석 생성해 다운로드시킨다.
 *
 * 별도 S3 업로드 없이 동작하게 하기 위한 선택. 첫 행에 `id` 헤더,
 * 두 번째 행부터 예시 3개를 채워둔다. 파싱 시 첫 행 헤더는 자동 스킵된다.
 *
 * 파일명만 "완료일 변경" 도메인용으로 다르게 두어 운영자가 양식을 헷갈리지 않게 한다.
 */
export const downloadSettlementIdTemplate = (): void => {
  const rows: (string | number)[][] = [['id'], [1111], [2222], [3333]];
  const sheet = XLSX.utils.aoa_to_sheet(rows);
  // 첫 컬럼 폭을 넓혀 ID가 잘 보이게
  sheet['!cols'] = [{ wch: 14 }];
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, '정산ID리스트');
  XLSX.writeFile(workbook, '정산_완료일_변경_ID_템플릿.xlsx');
};
